/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import {
  GetMcpNetworkTrafficPayload,
  GetMcpNetworkTrafficPayload$Outbound,
  GetMcpNetworkTrafficPayload$outboundSchema,
} from "../components/getmcpnetworktrafficpayload.js";

export type GetMcpNetworkTrafficSecurityOption1 = {
  apikeyHeaderGramKey: string;
  projectSlugHeaderGramProject: string;
};

export type GetMcpNetworkTrafficSecurityOption2 = {
  projectSlugHeaderGramProject: string;
  sessionHeaderGramSession: string;
};

export type GetMcpNetworkTrafficSecurity = {
  option1?: GetMcpNetworkTrafficSecurityOption1 | undefined;
  option2?: GetMcpNetworkTrafficSecurityOption2 | undefined;
};

export type GetMcpNetworkTrafficRequest = {
  /**
   * API Key header
   */
  gramKey?: string | undefined;
  /**
   * Session header
   */
  gramSession?: string | undefined;
  /**
   * project header
   */
  gramProject?: string | undefined;
  getMcpNetworkTrafficPayload: GetMcpNetworkTrafficPayload;
};

/** @internal */
export type GetMcpNetworkTrafficSecurityOption1$Outbound = {
  "apikey_header_Gram-Key": string;
  "project_slug_header_Gram-Project": string;
};

/** @internal */
export const GetMcpNetworkTrafficSecurityOption1$outboundSchema: z.ZodMiniType<
  GetMcpNetworkTrafficSecurityOption1$Outbound,
  GetMcpNetworkTrafficSecurityOption1
> = z.pipe(
  z.object({
    apikeyHeaderGramKey: z.string(),
    projectSlugHeaderGramProject: z.string(),
  }),
  z.transform((v) => {
    return remap$(v, {
      apikeyHeaderGramKey: "apikey_header_Gram-Key",
      projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
    });
  }),
);

export function getMcpNetworkTrafficSecurityOption1ToJSON(
  getMcpNetworkTrafficSecurityOption1: GetMcpNetworkTrafficSecurityOption1,
): string {
  return JSON.stringify(
    GetMcpNetworkTrafficSecurityOption1$outboundSchema.parse(
      getMcpNetworkTrafficSecurityOption1,
    ),
  );
}

/** @internal */
export type GetMcpNetworkTrafficSecurityOption2$Outbound = {
  "project_slug_header_Gram-Project": string;
  "session_header_Gram-Session": string;
};

/** @internal */
export const GetMcpNetworkTrafficSecurityOption2$outboundSchema: z.ZodMiniType<
  GetMcpNetworkTrafficSecurityOption2$Outbound,
  GetMcpNetworkTrafficSecurityOption2
> = z.pipe(
  z.object({
    projectSlugHeaderGramProject: z.string(),
    sessionHeaderGramSession: z.string(),
  }),
  z.transform((v) => {
    return remap$(v, {
      projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
      sessionHeaderGramSession: "session_header_Gram-Session",
    });
  }),
);

export function getMcpNetworkTrafficSecurityOption2ToJSON(
  getMcpNetworkTrafficSecurityOption2: GetMcpNetworkTrafficSecurityOption2,
): string {
  return JSON.stringify(
    GetMcpNetworkTrafficSecurityOption2$outboundSchema.parse(
      getMcpNetworkTrafficSecurityOption2,
    ),
  );
}

/** @internal */
export type GetMcpNetworkTrafficSecurity$Outbound = {
  Option1?: GetMcpNetworkTrafficSecurityOption1$Outbound | undefined;
  Option2?: GetMcpNetworkTrafficSecurityOption2$Outbound | undefined;
};

/** @internal */
export const GetMcpNetworkTrafficSecurity$outboundSchema: z.ZodMiniType<
  GetMcpNetworkTrafficSecurity$Outbound,
  GetMcpNetworkTrafficSecurity
> = z.pipe(
  z.object({
    option1: z.optional(
      z.lazy(() => GetMcpNetworkTrafficSecurityOption1$outboundSchema),
    ),
    option2: z.optional(
      z.lazy(() => GetMcpNetworkTrafficSecurityOption2$outboundSchema),
    ),
  }),
  z.transform((v) => {
    return remap$(v, {
      option1: "Option1",
      option2: "Option2",
    });
  }),
);

export function getMcpNetworkTrafficSecurityToJSON(
  getMcpNetworkTrafficSecurity: GetMcpNetworkTrafficSecurity,
): string {
  return JSON.stringify(
    GetMcpNetworkTrafficSecurity$outboundSchema.parse(
      getMcpNetworkTrafficSecurity,
    ),
  );
}

/** @internal */
export type GetMcpNetworkTrafficRequest$Outbound = {
  "Gram-Key"?: string | undefined;
  "Gram-Session"?: string | undefined;
  "Gram-Project"?: string | undefined;
  GetMcpNetworkTrafficPayload: GetMcpNetworkTrafficPayload$Outbound;
};

/** @internal */
export const GetMcpNetworkTrafficRequest$outboundSchema: z.ZodMiniType<
  GetMcpNetworkTrafficRequest$Outbound,
  GetMcpNetworkTrafficRequest
> = z.pipe(
  z.object({
    gramKey: z.optional(z.string()),
    gramSession: z.optional(z.string()),
    gramProject: z.optional(z.string()),
    getMcpNetworkTrafficPayload: GetMcpNetworkTrafficPayload$outboundSchema,
  }),
  z.transform((v) => {
    return remap$(v, {
      gramKey: "Gram-Key",
      gramSession: "Gram-Session",
      gramProject: "Gram-Project",
      getMcpNetworkTrafficPayload: "GetMcpNetworkTrafficPayload",
    });
  }),
);

export function getMcpNetworkTrafficRequestToJSON(
  getMcpNetworkTrafficRequest: GetMcpNetworkTrafficRequest,
): string {
  return JSON.stringify(
    GetMcpNetworkTrafficRequest$outboundSchema.parse(
      getMcpNetworkTrafficRequest,
    ),
  );
}
